function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 341.333 341.333"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M341.333 149.333H81.707L200.853 30.187 170.667 0 0 170.667l170.667 170.666 30.186-30.186L81.707 192h259.626z"
})));